import AnimatedMap from '../animatedMap/AnimatedMap';
import styles from './Home.module.css';

const serviceSlideFirst = (name,description) => {
    return (
        <div className={styles.slideContainer}>
            <div className={`${styles.slideForeground} ${styles.overlayGradient}`}>
                <div className={styles.firstSlideLayout}>
                    <div>
                        <h2>{name}</h2>
                        <h6>{description}</h6>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const serviceBlockData = [
    {
        name: 'Brand Development',
        path: 'brandDevelopment',
        description: 'We help to create brands that deliver the essence of your product or service. We offer support in logo design, brand positioning, tone of voice and everything else needed to help you resonate with your audience.',
        img: './imgs/brandDevelopment/trayFascia.jpg',
        slidesNew: [
            {
                slideContent(){ 
                    return ( serviceSlideFirst('Brand Development','We help to create brands that deliver the essence of your product or service. We offer support in logo design, brand positioning, tone of voice and everything else needed to help you resonate with your audience.')
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane}`}>
                                <div className={styles.fullHalfVideo}>
                                    <video autoPlay muted loop playsInline>
                                        <source src={('./imgs/guidelineAnimation.mp4')} type="video/mp4"/>
                                    </video>
                                </div>
                                <div className={styles.textContainer}>
                                    <h3>Our work with Goodyear</h3>
                                    <br/>
                                    <h3 className={styles.grey}>4</h3>
                                    <h4 className={styles.grey}>brands</h4>
                                    <h3 className={styles.grey}>23</h3>
                                    <h4 className={styles.grey}>countries</h4>
                                    <h3 className={styles.grey}>1000</h3>
                                    <h4 className={styles.grey}>projects completed</h4>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}>
                            <div className={`${styles.contentImgPane}`}>
                                <div className={styles.fullImage} style={{backgroundImage: `url(./imgs/brandDevelopment/businessCards.jpg)`}}></div>
                                <div className={styles.textContainer}>
                                    <h3>Our work with Goodyear</h3>
                                    <br/>
                                    <h3>4</h3>
                                    <h4>brands</h4>
                                    <h3 className={styles.grey}>23</h3>
                                    <h4 className={styles.grey}>countries</h4>
                                    <h3 className={styles.grey}>1000</h3>
                                    <h4 className={styles.grey}>projects completed</h4>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}>
                            <div className={`${styles.contentImgPane}`}>
                                {/* <div className={styles.fullImage} style={{backgroundImage: `url(./imgs/brandDevelopment/totem.jpg)`}}></div> */}
                                <div className={styles.mapContainer}>
                                    <div className={styles.mapInnerContainer}>
                                        <AnimatedMap mapWidth={null} mapHeight={'100%'} resetWidth={active}/>
                                    </div>
                                </div>
                                <div className={styles.textContainer}>
                                    <h3>Our work with Goodyear</h3>
                                    <br/>
                                    <h3>4</h3>
                                    <h4>brands</h4>
                                    <h3>23</h3>
                                    <h4>countries</h4>
                                    <h3 className={styles.grey}>1000</h3>
                                    <h4 className={styles.grey}>projects completed</h4>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}>
                            <div className={`${styles.contentImgPane}`}>
                                <div className={styles.fullImage} style={{backgroundImage: `url(./imgs/brandDevelopment/serviceSign.jpg)`}}></div>
                                <div className={styles.textContainer}>
                                    <h3>Our work with Goodyear</h3>
                                    <br/>
                                    <h3>4</h3>
                                    <h4>brands</h4>
                                    <h3>23</h3>
                                    <h4>countries</h4>
                                    <h3>1000</h3>
                                    <h4>projects completed</h4>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.portraitThirds}`}>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/brandDevelopment/fasciaFront.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1)'}`}}>
                           <div className={`${styles.contentImgPane} ${styles.portraitThirds}`}>
                                <div className={`${styles.fullImage} ${styles.mobile}`} style={{backgroundImage: `url('./imgs/brandDevelopment/fasciaFront.jpg')`}}></div>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/brandDevelopment/badgeFront.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
                        {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.portraitThirds}`}>
                                <div className={`${styles.fullImage} ${styles.mobile}`} style={{backgroundImage: `url('./imgs/brandDevelopment/fasciaFront.jpg')`}}></div>
                                <div className={`${styles.fullImage} ${styles.mobile}`} style={{backgroundImage: `url('./imgs/brandDevelopment/badgeFront.jpg')`}}></div>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/brandDevelopment/entranceFront.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane}`}>
                                <div className={styles.textContainer}>
                                    <h5>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.</h5>
                                </div>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/brandDevelopment/trayFascia.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={styles.firstImgPane}>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/brandDevelopment/entrance.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            }
        ]
    },
    {
        name: 'Brand Experience',
        path: 'brandExperience',
        description: 'When it comes to exhibitions its important that your experience is both true to your brand but also unique. Our aim is to create unique experiences that help your brand resonate with your audience and rise above the competition, whilst considering the importance of re-use and sustainability at all times.Our experienced designers work with you and your team throughout the design, build, delivery and installation phases to ensure your event is a success.',
        img: './imgs/nov2025Imgs/visionPurpose/browntable_new_o.jpg',
        slidesNew: [
            {
                slideContent(){
                    return (
                        serviceSlideFirst('Brand Experience','When it comes to exhibitions its important that your experience is both true to your brand but also unique. Our aim is to create unique experiences that help your brand resonate with your audience and rise above the competition, whilst considering the importance of re-use and sustainability at all times.Our experienced designers work with you and your team throughout the design, build, delivery and installation phases to ensure your event is a success.')
                    )
                }
            }
        ],
    },
    {
        name: 'Interior Design & Visualisation',
        path: 'interiorDesignVisualisation',
        description: 'We design, manage and fuse both structural and interior design in one streamlined process in house. This continuity, and by combining our efforts and knowledge, allows us to deliver more cohesive, and holistic spatial solutions at a higher calibre.',
        img: './imgs/interiorDesVis/bicesterRender.jpg',
        slidesNew: [
            {
                slideContent(){
                    return (
                        serviceSlideFirst('Interior Design & Visualisation','We design, manage and fuse both structural and interior design in one streamlined process in house. This continuity, and by combining our efforts and knowledge, allows us to deliver more cohesive, and holistic spatial solutions at a higher calibre.')
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane}`}>
                                <div className={styles.imgContainer}>
                                    <img src={`./imgs/interiorDesVis/carliMettetOverview.jpg`} />
                                </div>
                                <div className={styles.textContainer} style={{padding: '0 4rem'}}>
                                    <h4>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.</h4>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={styles.firstImgPane}>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/interiorDesVis/premioIdeal1.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            // {
            //     slideContent(active){ 
            //         return (
            //             <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1)'}`}}>
            //                 <div className={`${styles.contentImgPane} ${styles.twoImages}`}>
            //                     <div className={styles.imgContainer}>
            //                         <img src={`./imgs/interiorDesVis/carliMettetOverview.jpg`} />
            //                     </div>
            //                     <div className={styles.imgContainer}>
            //                         <img src={`./imgs/interiorDesVis/carliMettet1.jpg`} />
            //                     </div>
            //                 </div>
            //             </div>
            //         )
            //     }
            // },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.twoImages}`}>
                                <div className={styles.imgContainer}>
                                    <img src={`./imgs/interiorDesVis/frenchSite1.jpg`} />
                                </div>
                                <div className={styles.fullImage} style={{backgroundImage: `url(./imgs/interiorDesVis/vulcoWaitingArea.jpg)`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.twoImages}`}>
                                <div className={styles.imgContainer}>
                                    <img src={`./imgs/interiorDesVis/frenchSite1.jpg`} />
                                </div>
                                <div className={styles.textDivRight}>
                                    <h4>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.</h4>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={styles.firstImgPane}>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/interiorDesVis/redditchOverview.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.thirds}`}>
                                <div className={styles.imgContainer}>
                                    <img src={`./imgs/interiorDesVis/waitingRender.jpg`} />
                                </div>
                                <div style={{gridArea: '1/2/2/4'}}>
                                    <div className={styles.containedImage} style={{backgroundImage: `url(./imgs/interiorDesVis/waitingRender3.jpg)`}}></div>
                                </div>
                                <div style={{gridArea: '2/2/3/4'}}>
                                    <div className={styles.containedImage} style={{backgroundImage: `url(./imgs/interiorDesVis/waitDeskTyreRender.jpg)`}}></div>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.twoImages}`}>
                                <div style={{padding: '0 0 0 4rem'}}>
                                    <h4 style={{textAlign: 'right'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut semper ex at sapien blandit rutrum. Fusce lorem sem, rhoncus sed turpis ut, lobortis viverra quam. Nulla facilisi. Aliquam erat volutpat. Mauris vel euismod eros, quis auctor dolor. Nullam a ante eget risus ornare semper at non tortor.</h4>
                                </div>
                                <div className={styles.imgContainer}>
                                    <img src={`./imgs/interiorDesVis/waitDeskTyreRender.jpg`} />
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer} style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={styles.firstImgPane}>
                                <div className={styles.fullImage} style={{backgroundImage: `url('./imgs/interiorDesVis/final4comp.jpg')`}}></div>
                            </div>
                        </div>
                    )
                }
            },
            {
                slideContent(active){ 
                    return (
                        <div className={styles.scaleContainer}  style={{transform: `${active? 'scale(1)' : 'scale(1.1)'}`}}>
                            <div className={`${styles.contentImgPane} ${styles.twoImages}`}>
                                <div className={styles.imgContainer}>
                                    <img src={`./imgs/interiorDesVis/staffAfter.jpg`} />
                                </div>
                                <div className={styles.fullImage} style={{backgroundImage: `url(./imgs/interiorDesVis/waitingAftercomp.jpg)`}}></div>
                            </div>
                        </div>
                    )
                }
            }
        ],
        
    },
    {
        name: 'Industrial Product Design',
        path: 'industrialProductDesign',
        description: 'We dedicate our time to our clients to understand their vision, thoroughly define the brief or underpin the problem at its source, to deliver considered and well executed products by blending creative vision and technical know-how with our own twist.',
        img: './imgs/nov2025Imgs/designStrategy/web/kioskBin_comp.jpg',
        slidesNew: [
            {
                slideContent() {
                    return (
                        serviceSlideFirst('Industrial Product Design','We dedicate our time to our clients to understand their vision, thoroughly define the brief or underpin the problem at its source, to deliver considered and well executed products by blending creative vision and technical know-how with our own twist.')
                    )
                }
            }
        ]
    },
    {
        name: 'Digital Design',
        path: 'digitalDesign',
        description: 'We dedicate our time to our clients to understand their vision, thoroughly define the brief or underpin the problem at its source, to deliver considered and well executed products by blending creative vision and technical know-how with our own twist.',
        img: './imgs/nov2025Imgs/aboutUs/guyWork_comp.jpg',
        slidesNew: [
            {
                slideContent() {
                    return (
                        serviceSlideFirst('Digital Design','We dedicate our time to our clients to understand their vision, thoroughly define the brief or underpin the problem at its source, to deliver considered and well executed products by blending creative vision and technical know-how with our own twist.')
                    )
                }
            }
        ],
    }
];